import type { ChildId } from './valueObjects/childId';
import type { DefecationCategory } from './valueObjects/defecationCategory';
import type { MeasureDateTime } from './valueObjects/measureDateTime';
import type { MeasurerId } from './valueObjects/measurerId';
import type { MeasurerType } from './valueObjects/measurerType';
import type { ParentId } from './valueObjects/parentId';
import type { DefecationJsonPub, DefecationJsonPvt } from '@/types/domain/defecation/entities/defecationEntity';

import {
  EntityPub,
} from '@/domain/entityPub';
import { DeleteType } from '@/domain/entityRepositoryBase';
import {
  EntityName,
} from '@/infra/appsync';

/**
 * 排泄プロパティ非公開
 */
export type DefecationPropsPvt = {
  /** 測定日時 */
  measureDateTime: MeasureDateTime,
  /** 測定者ID */
  measurerId: MeasurerId,
  /** 測定タイプ */
  measurerType: MeasurerType,
  /** 親ID */
  parentId: ParentId,
  /** 子ID */
  childId: ChildId,
  /** 排泄カテゴリ */
  defecationCategory: DefecationCategory,
}

/**
 * 排泄プロパティ公開
 */
export type DefecationPropsPub = Record<string, never>

/**
 * 排泄Entity
 */
export class DefecationEntity extends EntityPub<
  DefecationPropsPvt,
  DefecationJsonPvt,
  DefecationPropsPub,
  DefecationJsonPub
> {
  get deleteType(): DeleteType {
    return DeleteType.ParentChildId;
  }

  get deleteKey(): string {
    return this.parentChildId;
  }

  toJsonData(): DefecationJsonPvt {
    return {
      measureDateTime: this.measureDateTime.value.toJSON(),
      measurerId: this.measurerId.value,
      measurerType: this.measurerType.value,
      parentId: this.parentId.value,
      childId: this.childId.value,
      defecationCategory: this.defecationCategory.value,
    };
  }

  toJsonPubData(): DefecationJsonPub {
    return {};
  }

  /**
   * Entity名
   */
  get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryDefecationDefecationEntity;
    return name;
  }

  /**
   * Entityキー
   */
  get entityKey(): string {
    return `${this.measureDateTime.toStringDateTime()}#${this.parentId.value}_${this.childId.value}#${this.measurerType.value}#${this.measurerId.value}`;
  }

  /**
   * サブキー
   */
  get subKey(): string {
    return `${this.parentId.value}_${this.childId.value}#${this.measureDateTime.toStringDateTime()}#${this.measurerType.value}#${this.measurerId.value}`;
  }

  /**
   * 親子ID
   */
  get parentChildId(): string {
    return `${this.parentId.value}_${this.childId.value}`;
  }

  /**
   * 測定日時
   */
  get measureDateTime(): MeasureDateTime {
    return this._value.measureDateTime;
  }

  /**
   * 排泄カテゴリ
   */
  get defecationCategory(): DefecationCategory {
    return this._value.defecationCategory;
  }

  /**
   * 測定者ID
   */
  get measurerId(): MeasurerId {
    return this._value.measurerId;
  }

  /**
   * 測定タイプ
   */
  get measurerType(): MeasurerType {
    return this._value.measurerType;
  }

  /**
   * 親ID
   */
  get parentId(): ParentId {
    return this._value.parentId;
  }

  /**
   * 子ID
   */
  get childId(): ChildId {
    return this._value.childId;
  }
}
